var React = require('react');

function Hide (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"style":{"fill":"none","stroke":"#1797E5","strokeWidth":"3.575","strokeLinecap":"round","strokeLinejoin":"round"},"x1":"30.29","y1":"9.71","x2":"9.71","y2":"30.29","key":0}),React.createElement("line",{"style":{"fill":"none","stroke":"#1797E5","strokeWidth":"3.575","strokeLinecap":"round","strokeLinejoin":"round"},"x1":"9.71","y1":"9.71","x2":"30.29","y2":"30.29","key":1})]));
}

Hide.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = Hide;

Hide.default = Hide;
